import { render, staticRenderFns } from "./PlanPagoPage.vue?vue&type=template&id=07d606d6"
import script from "./PlanPagoPage.js?vue&type=script&lang=js&external"
export * from "./PlanPagoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports